<template>
  <v-dialog v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick">
      <v-card>
        <v-card-text>
          <v-textarea
            auto-grow
            outlined
            v-model="notes"
            label="Notes"
            hide-details="auto"
          ></v-textarea>
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { ActivatorButton } from '@/components/pages'
  import { mapActions } from 'vuex'

  export default {
    name: 'NotesDialog',

    props: ['customer_request'],

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,
        
        notes: '',
      };
    },

    watch: {
      dialogVisible(visible) {
        if( visible ) {
          this.notes = this.customer_request.notes
        }
      },
    },

    methods: {
      ...mapActions('customer_requests', ['updateCurrent']),

      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        const { customer_request_id } = this.customer_request
        const { notes } = this

        let result = await this.updateCurrent ( { customer_request_id, notes } )
        if( result.ok ) {
          this.close()
        }
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position: absolute;
  }
</style>